"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityConfig = void 0;
const activity_core_1 = require("@ark/activity-core");
const utils_1 = require("@ark/utils");
exports.activityConfig = new activity_core_1.ActivityConfig({
    apiPrefix: 'material-checkin-2026',
    name: '物料打卡活动',
    description: '物料打卡活动活动包',
    businessLocations: [
        utils_1.BusinessLocation.SG,
        utils_1.BusinessLocation.MY,
        utils_1.BusinessLocation.CA,
        utils_1.BusinessLocation.AU,
    ],
});
